var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunicationCenterIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.313,
    height: 24.073,
    viewBox: "0 0 22.313 24.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_communication_center_1875745",
    "data-name": "noun_communication center_1875745",
    transform: "translate(-1.3 -10.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(1.3 10.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(0 14.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M23.613,52.522a.441.441,0,0,1-.44.44H1.74a.441.441,0,0,1-.44-.44,10.571,10.571,0,0,1,3.037-7.394A10.818,10.818,0,0,1,6.449,43.5a7.817,7.817,0,0,0,5.985,2.773,7.957,7.957,0,0,0,5.457-2.2l.572-.528A10.367,10.367,0,0,1,23.613,52.522Z",
    transform: "translate(-1.3 -43.5)",
    fill: "#f7f7f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(4.533 2.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(0.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M24.743,21.293a7.237,7.237,0,0,1-5.149.308,4.852,4.852,0,0,1-1.232-.66c-1.232-.924-3.873-2.024-6.161-.7a6.953,6.953,0,0,1,12.939.572Z",
    transform: "translate(-12.2 -16.1)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(0 4.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M17.057,32.467a1.878,1.878,0,0,0,1.892,1.892,1.931,1.931,0,0,0,1.364-.572h2.729A7,7,0,0,1,11.6,31.015a2.138,2.138,0,0,0,.748-1.672V28.2a2.1,2.1,0,0,0-.4-1.276c2.509-1.76,5.5.4,5.545.44a4.8,4.8,0,0,0,1.452.792,8.173,8.173,0,0,0,2.421.4,8.436,8.436,0,0,0,2.641-.44v1.276a2.29,2.29,0,0,0,.748,1.672c0,.044-.044.088-.044.132h-4.4a1.931,1.931,0,0,0-1.364-.572A1.815,1.815,0,0,0,17.057,32.467Z",
    transform: "translate(-11.6 -26.231)",
    fill: "#f7f7f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(1.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(0.963 7.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M8.273,27.588h0a1.218,1.218,0,0,1-.044.4.434.434,0,0,1-.44.4h0a.42.42,0,0,1-.4-.484.969.969,0,0,1,.044-.352,1.218,1.218,0,0,1,.4-.044A1.937,1.937,0,0,1,8.273,27.588Z",
    transform: "translate(-7.387 -27.5)",
    fill: "#f7f7f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(0 7.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M7.048,27.688h0a1.582,1.582,0,0,0-.484-.088,1.218,1.218,0,0,0-.4.044,1.373,1.373,0,0,0-.968,1.32v1.144a1.364,1.364,0,1,0,2.729,0V28.964A1.3,1.3,0,0,0,7.048,27.688Zm0,2.421a.484.484,0,0,1-.968,0V28.964a.488.488,0,0,1,.484-.484h0a.488.488,0,0,1,.484.484Z",
    transform: "translate(-5.2 -27.6)",
    fill: "#f7f7f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(0.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(14.699 7.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M41.1,26.8a1.376,1.376,0,0,0-.4.484Z",
    transform: "translate(-40.7 -26.8)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M25.256,19.278v1.144a1.436,1.436,0,0,1-.924,1.32v.88a1.371,1.371,0,0,1-1.364,1.364h-5.5a1.026,1.026,0,0,1-.924.572,1.012,1.012,0,0,1,0-2.024,1.026,1.026,0,0,1,.924.572h5.5a.488.488,0,0,0,.484-.484v-.88a1.392,1.392,0,0,1-.924-1.32V19.278A1.338,1.338,0,0,1,23.407,18,7.665,7.665,0,0,0,8.18,18a1.582,1.582,0,0,0-.484-.088,1.218,1.218,0,0,0-.4.044,8.539,8.539,0,0,1,16.988,0A1.373,1.373,0,0,1,25.256,19.278Z",
    transform: "translate(-7.3 -10.3)",
    fill: "#f7f7f7"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationCenterIconWhite);
export default __webpack_public_path__ + "static/media/communication-center-icon-white.85f3f6bd3d63228401a33d47d2429bf6.svg";
export { ForwardRef as ReactComponent };